<template>
  <div class="page-wrapper">
    <div class="container h-100 scroll-container">
      <div class="row" v-if="me != false">
        <div class="col-12 text-left section-header">
          My Information
        </div>
        <div class="col-12 text-left">
          <table class="user-info">
            <tr>
              <td>Name</td>
              <td>{{me.name}}</td>
            </tr>
            <tr>
              <td>Email</td>
              <td>{{me.email}}</td>
            </tr>
            <tr>
              <td>Level</td>
              <td>{{getUserLevelString(me.type)}}</td>
            </tr>
          </table>

        </div>

      </div>
      <div class="row text-left" style="margin-top:30px;">
        <div class="col-12">
          <button class="btn btn-dark" v-if="showPasswordChange == false" v-on:click="enableSetPassword">Change Password</button>
        </div>

      </div>
      <div class="row text-left" v-if="showPasswordChange">
        <div class="col-12">
          <table class="col-2-input-table">
            <tr>
              <td>Password</td>
              <td><input type="password" v-model="password"/></td>
            </tr>
            <tr>
              <td>Confirm Password</td>
              <td><input type="password" v-model="password2"/></td>
            </tr>
          </table>
        </div>
        <div class="col-12">
          <button class="btn btn-secondary" v-on:click="enableSetPassword">Cancel</button>
          <button class="btn btn-primary" v-on:click="verifyPassword">Update</button>
        </div>
      </div>
      <div class="row" v-if="me.type === 'ROLE_ADMIN' && me.canChangeAccess === true">
        <div class="col-12 section-header">
          User list
          <select v-model="userListType" style="margin-left: 20px; height: 30px; line-height: 30px; padding-left: 10px; padding-right: 10px;" @change="getUserList">
            <option value="">Select type</option>
            <option v-for="type in userLevel" :value="type.type" v-bind:key="'user-type-selector-'+type.type">{{type.title}}</option>
          </select>

          <button class="btn btn-primary" style="float:right" v-on:click="editUserItem(0)"><span class="fas fa-plus"></span> New</button>
        </div>
        <div class="col-12 text-left">
          <table class="table">
            <tr>
              <th>Role</th>
              <th>Org</th>
              <th>Login ID</th>
              <th>Name</th>

<!--              <th>Order</th>-->
<!--              <th>Product</th>-->
<!--              <th>Shops</th>-->
<!--              <th>Vendor</th>-->
<!--              <th>Vendor Order</th>-->
<!--              <th>Setting</th>-->
<!--              <th>Credit</th>-->
<!--              <th>Report</th>-->
<!--              <th>Noti</th>-->
              <th>Shift</th>
              <th></th>
            </tr>
            <tr v-for="user in users">
              <td>{{getUserLevelString(user.type)}}</td>
              <td><span >{{getMerchantName(user.merchantId)}}</span></td>
              <td>{{user.email}}</td>
              <td>{{user.name}}</td>

<!--              <td>{{user.orderAccessLevel}}</td>-->
<!--              <td>{{user.productAccessLevel}}</td>-->
<!--              <td>{{user.merchantAccessLevel}}</td>-->
<!--              <td>{{user.vendorAccessLevel}}</td>-->
<!--              <td>{{user.vendorOrderAccessLevel}}</td>-->
<!--              <td>{{user.settingAccessLevel}}</td>-->
<!--              <td>{{user.creditAccessLevel}}</td>-->
<!--              <td>{{user.reportAccessLevel}}</td>-->
<!--              <td>{{user.notificationAccessLevel}}</td>-->
              <td>{{getShiftTitle(user.defaultDriverShift)}}</td>
              <td><span v-on:click="editUserItem(user.id)"><i class="fas fa-edit"></i></span></td>
            </tr>
          </table>

        </div>
      </div>
      <div class="row">
        <div class="col-12" style="padding-bottom: 50px;">
          System Info: version: 250117
        </div>
      </div>

    </div>
    <transition name="slideup">
      <div class="form-background" v-if="editUser != false">
        <div class="form-body-container" style="width: 700px; max-width: 700px; max-height: 90%; overflow-y: auto;">
          <div class="container">
            <div class="row">
              <div class="col-12 form-header">
                Edit User
              </div>
            </div>
            <div class="row form-item-container">
              <div class="col-4">
                User ID
              </div>
              <div class="col-8">
                <input type="text" class="form-control" v-model="editUser.email" placeholder="User ID (Only lowercase, No Space or Special character)" :disabled="editUser.id > 0"/>
              </div>
            </div>
            <div class="row form-item-container">
              <div class="col-4">
                Name
              </div>
              <div class="col-8">
                <input type="text" class="form-control" v-model="editUser.name" placeholder="Name"/>
              </div>
            </div>
            <div class="row form-item-container">
              <div class="col-4">
                Password
              </div>
              <div class="col-8">
                <input type="text" class="form-control" v-model="editUser.password" placeholder="Password"/>
              </div>
            </div>
            <div class="row form-item-container">
              <div class="col-4">
                Password confirm
              </div>
              <div class="col-8">
                <input type="text" class="form-control" v-model="editUser.password2" placeholder="Confirm Password"/>
              </div>
            </div>
            <div class="row form-item-container">
              <div class="col-4">
                Role
              </div>
              <div class="col-8">
                <select class="form-control" v-model="editUser.type">
                  <option v-for="level in userLevel" :value="level.type">{{level.title}}</option>
                </select>
              </div>

            </div>
            <div class="row form-item-container" v-if="editUser.type === 'ROLE_DRIVER'">
              <div class="col-4">
                Default Shift
              </div>
              <div class="col-8">
                <select v-model="editUser.defaultDriverShift" class="form-control">
                  <option v-for="s in shiftList" :value="s.value">{{s.title}}</option>
                </select>
              </div>
            </div>
            <div class="row form-item-container" v-if="editUser.type === 'ROLE_STOCK_MANAGER' || editUser.type === 'ROLE_ADMIN'">
              <div class="col-12 form-section-header">
                <b>WMS Permission</b>
              </div>
              <div class="col-3">
                <div class="selectable-btn" :class="{'selected': editUser.wmsManage === true}" @click="editUser.wmsManage = !editUser.wmsManage">Stock Manage</div>
              </div>
              <div class="col-3">
                <div class="selectable-btn" :class="{'selected': editUser.wmsPick === true}" @click="editUser.wmsPick = !editUser.wmsPick">Picking</div>
              </div>
              <div class="col-3">
                <div class="selectable-btn" :class="{'selected': editUser.wmsPickCheck === true}" @click="editUser.wmsPickCheck = !editUser.wmsPickCheck">Check</div>
              </div>
              <div class="col-3">
                <div class="selectable-btn" :class="{'selected': editUser.wmsPickConfirm === true}" @click="editUser.wmsPickConfirm = !editUser.wmsPickConfirm">Confirm</div>
              </div>
            </div>
            <div class="row" v-if="me.canChangeAccess === true">
              <div class="col-12 form-section-header">
                Permissions
              </div>
              <div class="col-3">
                <div class="kh-btn kh-btn-smaller" :class="{'kh-9': editUser.canChangeAccess === true}" @click="editUser.canChangeAccess = !editUser.canChangeAccess">Control Access</div>
              </div>
            </div>
            <div class="row">
              <div class="col-12 form-section-header">
                <b>Orders Page</b>
              </div>
              <div class="col-3">
                <div class="kh-btn kh-btn-smaller" :class="{'kh-4': editUser.accessOrder === true}" @click="editUser.accessOrder = !editUser.accessOrder">Access</div>
                Access to order page
              </div>
              <div class="col-3">
                <div class="kh-btn kh-btn-smaller" :class="{'kh-4': editUser.editOrder === true}" @click="editUser.editOrder = !editUser.editOrder">Change Order</div>
                Edit quantity of items
              </div>
              <div class="col-3">
                <div class="kh-btn kh-btn-smaller" :class="{'kh-4': editUser.editOrderDiscount === true}" @click="editUser.editOrderDiscount = !editUser.editOrderDiscount">Discount</div>
                Give discount
              </div>
              <div class="col-3">
                <div class="kh-btn kh-btn-smaller" :class="{'kh-4': editUser.cancelOrder === true}" @click="editUser.cancelOrder = !editUser.cancelOrder">Cancel</div>
                Cancel orders
              </div>
              <div class="col-3">
                <div class="kh-btn kh-btn-smaller" :class="{'kh-4': editUser.manageOrder === true}" @click="editUser.manageOrder = !editUser.manageOrder">Manage</div>
                Assign driver, change date, create orders, cancel orders
              </div>
              <div class="col-3">
                <div class="kh-btn kh-btn-smaller" :class="{'kh-4': editUser.manageOrderDriver === true}" @click="editUser.manageOrderDriver = !editUser.manageOrderDriver">Assign Driver</div>
                Change driver for orders
              </div>
            </div>
            <div class="row">
              <div class="col-12 form-section-header">
                <b>Products</b>
              </div>
              <div class="col-3">
                <div class="kh-btn kh-btn-smaller" :class="{'kh-4': editUser.accessProduct === true}" @click="editUser.accessProduct = !editUser.accessProduct">Access</div>
                Access to product page
              </div>
              <div class="col-3">
                <div class="kh-btn kh-btn-smaller" :class="{'kh-4': editUser.manageProduct === true}" @click="editUser.manageProduct = !editUser.manageProduct">Product Manage</div>
                Add / edit (price) / delete products
              </div>
              <div class="col-3">
                <div class="kh-btn kh-btn-smaller" :class="{'kh-4': editUser.manageProductStock === true}" @click="editUser.manageProductStock = !editUser.manageProductStock">Stock Manage</div>
                Add/edit inventories, add new in/out record
              </div>
              <div class="col-3">
                <div class="kh-btn kh-btn-smaller" :class="{'kh-4': editUser.viewProductCost === true}" @click="editUser.viewProductCost = !editUser.viewProductCost">View Product Cost</div>
                View Prime cost & Margin
              </div>

            </div>
            <div class="row">
              <div class="col-12 form-section-header">
                <b>Shops</b>
              </div>
              <div class="col-3">
                <div class="kh-btn kh-btn-smaller" :class="{'kh-4': editUser.accessShop === true}" @click="editUser.accessShop = !editUser.accessShop">Access</div>
                Access to Shop page
              </div>
              <div class="col-3">
                <div class="kh-btn kh-btn-smaller" :class="{'kh-4': editUser.manageShopAccount === true}" @click="editUser.manageShopAccount = !editUser.manageShopAccount">Shop Manage</div>
                Add / edit / remove shops
              </div>
<!--              <div class="col-3">-->
<!--                <div class="kh-btn kh-btn-smaller" :class="{'kh-4': editUser.manageProductStock === true}" @click="editUser.manageProductStock = !editUser.manageProductStock">Stock Manage</div>-->
<!--              </div>-->

            </div>
            <div class="row">
              <div class="col-12 form-section-header">
                <b>Credit</b>
              </div>
              <div class="col-3">
                <div class="kh-btn kh-btn-smaller" :class="{'kh-4': editUser.accessCredit === true}" @click="editUser.accessCredit = !editUser.accessCredit">Access</div>
                Access to Credit page
              </div>
              <div class="col-3">
                <div class="kh-btn kh-btn-smaller" :class="{'kh-4': editUser.manageCredit === true}" @click="editUser.manageCredit = !editUser.manageCredit">Manage Credit</div>
                Create/Cancel
              </div>


            </div>
            <div class="row">
              <div class="col-12 form-section-header">
                <b>Report</b>
              </div>
              <div class="col-3">
                <div class="kh-btn kh-btn-smaller" :class="{'kh-4': editUser.accessReport === true}" @click="editUser.accessReport = !editUser.accessReport">Access</div>
                Access to Report page and view
              </div>



            </div>

            <div class="row">
              <div class="col-12 form-section-header">
                <b>Vendors</b>
              </div>
              <div class="col-3">
                <div class="kh-btn kh-btn-smaller" :class="{'kh-4': editUser.accessVendor === true}" @click="editUser.accessVendor = !editUser.accessVendor">Access</div>
                Access to Vendor page
              </div>
              <div class="col-3">
                <div class="kh-btn kh-btn-smaller" :class="{'kh-4': editUser.manageVendor === true}" @click="editUser.manageVendor = !editUser.manageVendor">Manage Vendors</div>
                Add / edit (price) / delete vendors
              </div>
              <div class="col-3">
                <div class="kh-btn kh-btn-smaller" :class="{'kh-4': editUser.manageVendorOrders === true}" @click="editUser.manageVendorOrders = !editUser.manageVendorOrders">Vendor Orders</div>
                Add/edit/submit orders from KTL/shops to vendors
              </div>

            </div>


            <div class="row">
              <div class="col-12 form-section-header">
                <b>Suppliers</b>
              </div>
              <div class="col-3">
                <div class="kh-btn kh-btn-smaller" :class="{'kh-4': editUser.accessSuppliers === true}" @click="editUser.accessSuppliers = !editUser.accessSuppliers">Access</div>
                Access to Vendor page
              </div>
              <div class="col-3">
                <div class="kh-btn kh-btn-smaller" :class="{'kh-4': editUser.manageSuppliers === true}" @click="editUser.manageSuppliers = !editUser.manageSuppliers">Manage Suppliers</div>
                Add / edit (price) / delete Suppliers
              </div>
              <div class="col-3">
                <div class="kh-btn kh-btn-smaller" :class="{'kh-4': editUser.manageSupplierOrders === true}" @click="editUser.manageSupplierOrders = !editUser.manageSupplierOrders">Orders to Suppliers</div>
                Add/edit/submit orders from KTL to Suppliers
              </div>

            </div>

            <div class="row">
              <div class="col-12 form-section-header">
                <b>Notification Page</b>
              </div>
              <div class="col-6">
                <div class="kh-btn kh-btn-smaller" :class="{'kh-4': editUser.manageNotification === true}" @click="editUser.manageNotification = !editUser.manageNotification">Access / Manage</div>
                Access to Notification Page, issue new notifications
              </div>



            </div>
            <div class="row" style="padding-top: 10px;">
              <div class="col-4">
                <button class="btn btn-secondary form-control" v-on:click="cancelEditUser">Cancel</button>
              </div>
              <div class="col-4">
                <button class="btn btn-danger form-control" v-if="editUser.id > 0" @click="deleteUser">Delete</button>
              </div>
              <div class="col-4">
                <button class="btn btn-primary form-control" v-on:click="submitEditUser"><span v-if="editUser.id == 0">Create</span><span v-else>Update</span></button>
              </div>
            </div>
          </div>
        </div>
      </div>
    </transition>


  </div>
</template>

<script>
  import {getMerchants} from "../api/merchant";

  require('@/assets/css/styles.css')
    var XLSX = require('xlsx');
    import {getMetasByType, getMetaByType, updateMetaItem, deleteMeta} from "../api/meta";
  import {
    addUser,
    getUserList,
    createUsers,
    updateUser,
    getUserByToken,
    createNewUser,
    getUser,
    deleteUser
  } from "../api/user";
    import {getProductById} from "../api/product";
  import {generateOrderNumber, getShiftList, setLastPage, showDialog} from "../api/utils";

    import ImageInput from "./ImageInput";
    import draggable from 'vuedraggable';
    import moment from 'moment';

    export default {
        name: "Setting",
        data() {
            return {
                users:[],
                me:false,
                merchants: [],
                showPasswordChange: false,
                password:'',
                password2:'',
                shiftList:getShiftList(),
                userLevel: [
                  {
                    value:'admin',
                    title:'Admin',
                    type:'ROLE_ADMIN',
                  },
                  {
                    value:'manager',
                    title:'Manager',
                    type:'ROLE_MANAGER',
                  },
                  {
                    value:'online manager',
                    title:'online Manager',
                    type:'ROLE_MALL_MANAGER',
                  },
                  {
                    value:'staff',
                    title:'Staff',
                    type:'ROLE_STAFF',
                  },
                  {
                    value:'merchant',
                    title:'Merchant',
                    type:'ROLE_MERCHANT',
                  },
                  {
                    value:'stock_manager',
                    title:'Warehouse',
                    type:'ROLE_STOCK_MANAGER',
                  },
                  {
                    value:'driver',
                    title:'Driver',
                    type:'ROLE_DRIVER',
                  }

                ],
                staffLevel: [
                  {
                    value:'admin',
                    title:'Admin',
                    type:'ROLE_ADMIN',
                  },
                  {
                    value:'manager',
                    title:'Manager',
                    type:'ROLE_MANAGER',
                  },
                  {
                    value:'stock_manager',
                    title:'Stock Manager',
                    type:'ROLE_STOCK_MANAGER',
                  },
                  {
                    value:'staff',
                    title:'Staff',
                    type:'ROLE_STAFF',
                  },
                  ,
                  {
                    value:'driver',
                    title:'Driver',
                    type:'ROLE_DRIVER',
                  },
                ],
                editUser:false,
                userListType:'',
                accessLevelList: [
                  {title:'No access', value: 0},
                  {title:'Level 1', value: 1},
                  {title:'Level 2', value: 2},
                  {title:'Level 3', value: 3},
                ]
            }
        },
        components: {
            ImageInput,
            draggable,
        },
        created() {
          setLastPage(this.$route.path);
            // this.getProductOptionList();
        },
        mounted() {
            this.getMerchantList();
            this.getMyInfo();
        },
        methods: {
            getUserLevelString: function(role) {
              for(let i = 0 ; i < this.$data.userLevel.length ; i++) {
                if(this.$data.userLevel[i].type === role) {
                  return this.$data.userLevel[i].title;
                }
              }
              return role;
            },
            getMyInfo: function() {
              let self = this;
              getUserByToken()
              .then(function(data) {
                self.$data.me = data;
                console.log(data);
                // if(self.$data.me.type === 'ROLE_ADMIN') {
                //   self.getUserList();
                // }
              })
              .catch(function(err) {

              })
            },
          getShiftTitle: function(val) {
            for(let i = 0 ; i < this.$data.shiftList.length ; i++) {
              if(this.$data.shiftList[i].value === val) {
                return this.$data.shiftList[i].title;
              }
            }
            return 'Unknown(' + val + ')';
          },
            getMerchantName: function(id) {
              if(id === 0) {
                return 'KTL';
              }
              if(this.$data.merchants.length == 0) {
                return 'Not Found';
              }

              for(let i = 0 ; i < this.$data.merchants.length ; i++) {
                if(this.$data.merchants[i].id == id) {
                  return this.$data.merchants[i].title;
                }
              }
              return 'Unknown(' + id + ')';
            },
            getMerchantList: function() {
                let self = this;
                getMerchants()
              .then(function(data) {
                if(data.success == true) {
                  self.$data.merchants = data.item;
                }
              })
            },
            getUserList: function() {
              if(this.$data.userListType === null || this.$data.userListType === '') {
                showDialog("Please select user type");
                return;
              }
              this.$data.users = [];
              let self = this;


              console.log("get user list");
              getUserList(this.$data.userListType)
              .then(function(data) {
                if(data.success == true) {
                  data.item.sort(function(a, b) {
                    if(a.name.toUpperCase() > b.name.toUpperCase()) {
                      return 1;
                    } else if(a.name.toUpperCase() < b.name.toUpperCase()) {
                      return -1;
                    }
                    return 0;
                  })
                  self.$data.users = data.item;
                }
              })
              .catch(function(err) {

              })
            },
            enableSetPassword: function() {
              this.$data.showPasswordChange = !this.$data.showPasswordChange ;
            },
            verifyPassword: function() {
              if(this.$data.password == undefined || this.$data.password.length < 4) {
                showDialog("Password must at list 4 digits");
                return;
              }
              if(this.$data.password !== this.$data.password2) {
                showDialog("Passwords are not matching");
                return;
              }


            },
            showModal: function(title, message) {
                console.log("show modal " + title  + " : " + message);
                this.$modal.show('dialog',{
                    title: title,
                    text: message,
                    buttons:[
                        {title:'Close'}
                    ]
                })
                return;
            },
            editUserItem: function(id = 0) {
              if(id == 0) {
                this.$data.editUser = createNewUser();
              } else {
                let self = this;
                getUser(id)
                .then(function(data) {
                  if(data.success == true) {
                    self.$data.editUser = data.item;
                  } else {
                    showDialog(data.message);
                  }
                })
                .catch(function(err) {
                  showDialog("Error " + err);
                })

              }
            },
            cancelEditUser: function () {
              this.$data.editUser = false;

            },

            submitEditUser: function() {
              if(this.$data.editUser.id == 0) {
                // Check password matching
                if(this.$data.editUser.password == null || this.$data.editUser.password.length < 4) {
                  showDialog("Please enter password");
                  return;
                }

                if(this.$data.editUser.password !== this.$data.editUser.password2) {
                  showDialog("Passwords are not matching", "Password error");
                  return;
                }
              } else if(this.$data.editUser.password != null && this.$data.editUser.password.length > 0 && this.$data.editUser.password !== this.$data.editUser.password2) {
                showDialog("Passwords are not matching", "Password error");
                return;
              }

              if(this.$data.editUser.name == null || this.$data.editUser.name.length == 0) {
                showDialog("Please enter name of user");
                return;
              }

              if(this.$data.editUser.email == null || this.$data.editUser.email.length == 0) {
                showDialog("Please enter user email");
                return;
              }

              let self = this;
              console.log("New user ");
              console.log(this.$data.editUser);
              updateUser(this.$data.editUser)
              .then(function(data) {
                if(data.success == true) {

                  console.log("new user created");
                  console.log(data.item);
                  for(let i = 0 ; i < self.$data.users.length ; i++) {
                    if(self.$data.users[i].id == data.item.id) {
                      self.$data.users.splice(i, 1, data.item);
                      self.$data.editUser = false;
                      return;
                    }
                  }
                  self.$data.users.push(data.item);
                  self.$data.editUser = false;
                } else {
                  showDialog("Failed to update " + data.message);
                }
              })
              .catch(function(err) {
                showDialog("Error occurred " + err);
              })
            },
          deleteUser: function() {
            if(this.$data.editUser === null || this.$data.editUser === false) {
              return;
            }

            let self = this;
            this.$modal.show('dialog',{
              title: "Delete User",
              text: "Are you sure to delete user " + this.$data.editUser.email + "?",
              buttons: [
                {
                  title: 'No',
                  handler: () => {
                    self.$modal.hide('dialog');

                  }
                },
                {
                  title: 'Yes Delete',
                  handler: () => {
                    self.$modal.hide('dialog');
                    self.deleteUserConfirmed();
                  }
                },

              ]
            })
          },
          deleteUserConfirmed: function() {

              let self = this;
            deleteUser(this.$data.editUser.id)
              .then(function(data) {
                if(data.success === true) {
                  self.$data.editUser = false;
                  for(let i = 0 ; i < self.$data.users.length ; i++) {
                    if(self.$data.users[i].id === data.item.id) {
                      self.$data.users.splice(i, 1);
                      return;
                    }
                  }
                } else {
                  showDialog(data.message);
                }
              })
              .catch(function(err) {
                showDialog("Error occurred " + err);
              })
          }
        },

    }
</script>

<style scoped>
  /*.form-container {*/
  /*  position: absolute;*/
  /*  background: rgba(0,0,0,0.4);*/
  /*  top: 0;*/
  /*  left: 0;*/
  /*  width: 100%;*/
  /*  height: 100%;*/
  /*  z-index: 998;*/
  /*}*/
  .form-inner-container {
    position: absolute;
    width: 80%;
    max-width: 700px;
    height: 80%;
    top: 50%;
    left: 50%;
    transform: translate(-50%,-50%);
    background: white;
    padding:50px;
    padding-bottom:70px;
    overflow-y: scroll;
  }
  .form-button-container {
    position: sticky;
    bottom:-70px;
    left: 0;
    width: 100%;
    padding:20px;
    background: white;
  }
  label.form-control {
    border:none;
  }
  .image-container {
    margin-bottom: 30px;
  }
  .image-container > img {
    max-width: 95%;
    max-height: 95%;
  }
  .image-input-container {
    position: fixed;
    bottom:20px;
    left:20px;
    width: 100px;
    height: 100px;
    border:3px solid gray;
  }



  .admin-unchecked {
    color:grey;
  }
  .admin-checked {
    color:blue;
  }
  tr:nth-child(odd){
    background-color: #ccc;
  }
  .selectable-btn {
    padding: 15px;
    border: 1px solid #ccc;
    background: #eee;
    text-align: center;
    border-radius: 10px;
    cursor: pointer;
  }
  .selectable-btn.selected {
    background: #0000FF;
    color: white;
    font-weight: bold;
  }

  .select-btn select {
    width: 100%;
    height: 40px;
    line-height: 40px;
    border: 1px solid #ccc;

  }

  .form-section-header {
    background: white;
    border-top: 1px solid #b2b2b2;
  }

  .form-item-container > div {
    height: 38px;
    line-height: 38px;
    padding-top: 0;
    padding-bottom: 0;
  }
</style>



// WEBPACK FOOTER //
// src/components/Setting.vue